// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"c464e2c1","303":"c0b48041","338":"9980fa41","396":"58cb88de"}[chunkId] + ".chunk.js";
};